module.exports = __webpack_public_path__ + "img/twitter.5d5d0aff.svg";